import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import { ExporoUser, IdToken } from '@/store/profile/types';

const isLocal = window.location.origin.includes('http://localhost');
const environment = process.env.NODE_ENV || null;

export function configSentry() {
  // configure Sentry
  // allow error tracking in staging / prod
  if (!isLocal && environment) {
    Sentry.init({
      dsn: 'https://6a99d9aec0e945dd820df10c98249b2a@o38895.ingest.sentry.io/5338303',
      integrations: [new VueIntegration({Vue, attachProps: true, logErrors: true})],
      environment,
    });
  }
}


export function identifySentryUser(user:ExporoUser, idToken: IdToken){
  if (!isLocal && environment) {
    // Capture user
    // https://docs.sentry.io/enriching-error-data/additional-data/?platform=javascript#capturing-the-user
    Sentry.setUser({
      id: idToken.user_id,
    });
    // Set user aditional information, as well as tags and further extras
    // https://docs.sentry.io/enriching-error-data/additional-data/?platform=javascript#custom-data
  }
}